import React from 'react';
import FloatingPopup from './FloatingPopup';
import { AlertTriangle } from 'lucide-react';
import { deleteBorrowerPair } from '../../services/borrowerApi';

const ConfirmDeleteBorrowerModal = ({ isOpen, onClose, borrowerPairId, token, loanid, onDeleted }) => {

    const handleDelete = async () => {
        try {
            await deleteBorrowerPair(token, loanid, borrowerPairId);
            onDeleted();
        } catch (err) {
            console.error("Failed to delete borrower pair", err);
        }
    };

    if (!isOpen) return null;

    return (
        <FloatingPopup title="" width="max-w-md" onClose={onClose}>
            <div className="flex flex-col items-center text-center">
                <AlertTriangle size={48} className="text-orange-500 mb-4" />
                <h2 className="text-lg font-semibold text-gray-800 mb-1">Delete this borrower pair?</h2>
                <p className="text-sm text-gray-600 mb-6">This action can't be undone</p>
                <div className="flex justify-center gap-3">
                    <button
                        onClick={onClose}
                        className="btn-custom border border-gray-300 rounded text-[#2080C3] bg-[#FFFFFF] active:bg-white transition-colors duration-200"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleDelete}
                        className="btn-custom rounded text-[#FFFFFF] bg-[#2080C3] hover:text-[#E6EEF8] hover:bg-[#5DA5D9] active:bg-white transition-colors duration-200"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </FloatingPopup>

    );
};

export default ConfirmDeleteBorrowerModal;
